import React from "react";
import { formatNumber } from "utils/currencyFormat";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import TextInputOnRow from "../../../../components/GenericComponent/TextInputOnRow";

export const TraLai = ({
  updateTextValue,
  onChangeDate,
  onChangeNumber,
  dataThanhToanAll,
  onSubmit,
  isSubmitting,
  NguoiNhan,
  TienThanhToan,
  errors,
  errors1,
  errors2,
  isShowFormDongLai,
}) => {
  return (
    <div
      class="donglai-form form-donglai-mobileshow"
      style={{ display: isShowFormDongLai ? "block" : "none" }}
    >
      <h4>
        <span style={{ fontWeight: "bold !important;" }}>
          {" "}
          <img
            src="/app-assets/images/icon-dong-lai.png"
            style={{ marginBottom: "5px" }}
          />
          &nbsp;&nbsp; Trả lãi
        </span>
      </h4>

      <div class="body-donglai">
        <div class="basic-form">
          <div class="form-group">
            <label class="text-label  color7-bold">Ngày thanh toán</label>
            <DateTimePicker
              value={convertDate(dataThanhToanAll.NgayThanhToan)}
              name="NgayThanhToan"
              onChange={onChangeDate("NgayThanhToan")}
              // customInputRef={NgayThanhToan}
            ></DateTimePicker>
            {errors1.ngayThanhToan && (
              <span className="canh-bao-red">{errors1.ngayThanhToan}</span>
            )}
          </div>
          <TextInputOnRow
            labelClass="label-control  color7-bold"
            inputClass="form-control input-sm"
            wrapperClass="form-group"
            labelText="Người nhận"
            inputProps={{
              name: "dataThanhToanAll.NguoiNhan",
              onChange: updateTextValue("NguoiNhan"),
              ref: NguoiNhan,
              value: dataThanhToanAll.NguoiNhan,
            }}
          ></TextInputOnRow>
          {errors.nguoiNhan && (
            <span className="canh-bao-red">{errors.nguoiNhan}</span>
          )}

          <TextInputOnRow
            labelClass="label-control  color7-bold"
            inputClass="form-control input-sm"
            wrapperClass="form-group"
            labelText="Tiền thanh toán"
            inputProps={{
              ref: TienThanhToan,
              name: "dataThanhToanAll.TienThanhToan",
              onChange: onChangeNumber("TienThanhToan"),
              value: formatNumber(dataThanhToanAll.TienThanhToan),
            }}
          ></TextInputOnRow>
          {errors2.TienThanhToan && (
            <span className="canh-bao-red">{errors2.TienThanhToan}</span>
          )}
          <TextInputOnRow
            labelClass="label-control  color7-bold"
            inputClass="form-control input-sm"
            wrapperClass="form-group"
            labelText="Phí khác"
            inputProps={{
              name: "dataThanhToanAll.PhiKhac",
              onChange: onChangeNumber("PhiKhac"),
              value: formatNumber(dataThanhToanAll.PhiKhac),
            }}
          ></TextInputOnRow>

          <div class="form-group ">
            <label class="text-label  color7-bold">Ghi chú</label>
            <textarea
              id="projectinput8"
              rows="2"
              class="form-control input-sm"
              name="GhiChu"
              value={dataThanhToanAll.GhiChu}
              onChange={updateTextValue("GhiChu")}
            ></textarea>
          </div>

          <div class="dropdown-divider"></div>
          <div class="text-right">
            <button
              type="button"
              class="btn btn-new-main btn-checknew"
              disabled={isSubmitting}
              onClick={onSubmit}
            >
              <span class="btn-icon-left">
                <i class="mdi mdi-check-underline-circle"></i>
              </span>{" "}
              Xác nhận
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
